import '../App.css';
import React, { useState } from 'react';
import styled from 'styled-components';
import { useSwipeable } from 'react-swipeable';
import { NavComponent } from '../navigationComponents/NavComponent';
import { HiChevronDown, HiChevronUp, HiArrowRightOnRectangle } from 'react-icons/hi2'; // Import arrow icons
import { FaArrowUp, FaArrowDown } from 'react-icons/fa'; // Import bolder arrows
import { FaAmazon, FaExternalLinkAlt } from 'react-icons/fa'; // Import Amazon icon

const StyledDiv = styled.div`
  margin: auto;
  padding: 15px;
  background-color: #333;
  opacity: 0.95;
  text-align: center;
  width: 70%;
  border-radius: 20px;
  outline: none;
  border: transparent;
  color: white;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
`;

const StyledHeader = styled.h1`
  opacity: 1;
  color: #b86fec;
  text-align: center;
  font-size: 2.5rem;
  text-shadow: 4px 4px 10px rgba(0, 0, 0, 0.7); /* Stronger shadow */
  margin-bottom: 20px;
`;

const StyledButton = styled.button`
  margin: 10px;
  padding: 10px 20px;
  background-color: ${(props) => (props.isSelected ? '#9a5ecb' : '#b86fec')}; /* Highlight selected button */
  color: white;
  border: none;
  border-radius: 10px;
  cursor: pointer;

  &:hover {
    background-color: ${(props) => (props.isSelected ? '#7a4db0' : '#9a5ecb')}; /* Slightly darker hover effect */
  }
`;

const StyledItemList = styled.ul`
  list-style-type: none;
  padding: 0;
`;

const StyledItem = styled.li`
  margin: 5px 0;
  padding: 10px;
  background-color: #444;
  border-radius: 10px;
  color: white;
`;

const CarouselContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 40px auto;
  width: '100%';
  height: 'auto';
  position: relative;
`;

const CarouselContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 'fit-content';
  height: 100%;
  background-color: #f9f9f9;
  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  text-align: center;
  font-family: 'Arial', sans-serif;
  font-size: 1.2rem;
  color: #333;
  transition: transform 0.3s ease, box-shadow 0.3s ease; /* Smooth transition for hover effects */

  
  &:hover {
    transform: scale(1.03); /* Slight zoom effect */
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2); /* Stronger shadow on hover */
    background-color: #ffffff; /* Optional: Slightly brighter background on hover */
  }
`;

const NavigationDots = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;
const Dot = styled.div`
  width: 12px;
  height: 12px;
  margin: 0 5px;
  background-color: ${(props) => (props.active ? '#b86fec' : '#ccc')};
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #9a5ecb;
  }
`;

const ArrowButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: transparent;
  border: none;
  font-size: 2.5rem; /* Increase size for better visibility */
  font-weight: bold; /* Make the arrows thicker */
  color: #b86fec;
  cursor: pointer;
  transition: color 0.3s ease;

  &:hover {
    color: #9a5ecb;
  }

  &:disabled {
    visibility: hidden;
  }

  /* Hide arrows on mobile devices */
  @media (max-width: 768px) {
    display: none;
  }
`;

const StyledButtonRequest = styled.button`

justify-content: center;
padding: 10px 20px;

  background-color: #black;
  color: white;
  border: 2px solid #9a5ecb; /* Added border color */
  border-radius: 15px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;

  &:hover {
    background-color: #9a5ecb;
    transform: scale(1.05); /* Slight zoom effect */
  }

  svg {
    margin-left: 8px; /* Space between text and icon */
    font-size: 20px;
  }
`;

function Shop() {
  const [category, setCategory] = useState('Europe');

    const [isVisibleCocktail, setIsVisibleCocktail] = useState(true);
    const [isVisibleDog, setIsVisibleDog] = useState(true);
    const [isVisibleVehicle, setIsVisibleVehicle] = useState(true);
    const [isVisibleNFL, setIsVisibleNFL] = useState(true);
    const [activeIndex, setActiveIndex] = useState(0);
    const [isAffiliateShopVisible, setIsAffiliateShopVisible] = useState(false); // State to toggle visibility

    const packages = [
      {
        id: 0,
        title: 'Reward Token for your Company',
        details: 'This package allows you to create a unique token for your company, which can be used as a reward for employees or customers.',
        features: ['Your Logo as your NFT', 'Your brand name as token'],
        customization: ['Basic Token', 'Advanced Token', 'Blockchain', 'Post-Delivery Support'],
        useCase: 'Ideal for companies looking to reward employees or customers with a unique token.',
        price: '€1000-€3000*',
      },
      {
        id: 1,
        title: 'Basic Token Package',
        details: 'A simple ERC-20 token with standard functionality.',
        features: ['ERC-20 Standard Token creation', 'Fixed supply (minted on deploy)', 'Basic branding (name, symbol, decimals)'],
        customization: ['Name, symbol, supply', 'Decimals (default: 18)', 'Blockchain'],
        useCase: 'Ideal for beginners, hobbyists or small projects.',
        price: '€380-€550*',
      },
      {
        id: 2,
        title: 'Advanced Token Package',
        details: 'A feature-rich token with economics and security features.',
        features: [
          'All Basic Package features',
          'Mint and Burn function',
          'Transfer tax (e.g. for dev/marketing)',
          'Anti-whale (max tx / wallet limit)',
          'Pause/unpause trading',
          'Owner-only controls'
          ],
        customization: ['Tax %, wallet limits','Burn option on/off','Ownership controls (pause/trading lock)'],
        useCase: 'Suitable for startups or businesses looking for more control, Startups, meme/token launches.',
        price: '€950-€1350*',
      },
      {
        id: 3,
        title: 'Custom Token Package',
        details: 'Fully customizable token tailored to your needs.',
        features: ['All Basic Package features', 'different Tokenomics / Transfer Mechanics', 'Governance / Control', 'Utility & Marketing', 'Dev/Launch Tools' ],
        customization: ['Token information (Name, symbol, supply, decimals)', 'Blacklist', 'Multi-Ownership', 'Airdrop to Whitelist'],
        useCase: 'Perfect for businesses or projects with unique requirements.',
        price: 'Starting at €350*',
      },
      {
        id: 4,
        title: 'Single NFT Drop',
        details: 'Create a single, unique NFT.',
        features: ['ERC-721/ERC-1155 token creation', 'Metadata customization (image, description, attributes)', 'Deployment and minting on a blockchain of your choice'],
        customization: ['Image', 'Metadata'],
        useCase: 'Ideal for artists or individuals looking to tokenize a single asset.',
        price: '€25-€125*',
      },
      {
        id: 5,
        title: 'Collection NFT Drop (Up to 50 NFTs)',
        details: 'Create a collection of NFTs.',
        features: ['NFT Collection creation', 'ERC-721/ERC-1155 token creation', 'Metadata customization (image, description, attributes)', 'Deployment and minting on a blockchain of your choice'],
        customization: ['Image x NFTs', 'Metadata x NFTs', 'Collection Name'],
        useCase: 'Perfect for artists, brands, or businesses launching a large-scale NFT project.',
        price: '€50 + €15-€130 per NFT*',
      },
    ];


    const itemsCocktails = {
        Europe: [' Cocktail Shaker Set ', ' Bar Deluxe Shaker ', ' Cocktail Glasses '],
        EuropeURL: ['https://amzn.to/4kW6Pj4', 'https://amzn.to/4mTV3HD', 'https://amzn.to/4l4SLUy'],
        Australia: [' Cocktail Shaker Set ', ' Bar Deluxe Shaker ', ' Cocktail Glasses '],
        AistraliaURL: ['https://amzn.to/4kW6Pj4', 'https://amzn.to/4mTV3HD', 'https://amzn.to/4l4SLUy'],
        China: [' Cocktail Shaker Set ', ' Bar Deluxe Shaker ', ' Cocktail Glasses '],
        ChinaURL: ['https://amzn.to/4kW6Pj4', 'https://amzn.to/4mTV3HD', 'https://amzn.to/4l4SLUy'],
    };

    const itemsDogs = {
        Europe: [' BULLDOG Sculpture Tablet ', ' Shiba Inu Coffee Mug ', ' Shiba Inu Stolze Mama Coffee Mug '],
        EuropeURL: ['https://www.amazon.de/OKESYO-Franz%C3%B6sische-Wohnzimmer-Eingangsbereich-Schreibtischdekoration/dp/B0C32MZH1Q?content-id=amzn1.sym.c1dd0633-066b-48a5-834b-1a99dc75ad66%3Aamzn1.sym.c1dd0633-066b-48a5-834b-1a99dc75ad66&cv_ct_cx=shiba%2Binu&keywords=shiba%2Binu&pd_rd_i=B0C32MZH1Q&pd_rd_r=a4e53393-171d-4355-b5e0-4b8ef0b5b5a4&pd_rd_w=ZAIde&pd_rd_wg=UxF2S&pf_rd_p=c1dd0633-066b-48a5-834b-1a99dc75ad66&pf_rd_r=81TGWY6NSGGGAZH526DB&qid=1749747969&sbo=RZvfv%2F%2FHxDF%2BO5021pAnSA%3D%3D&sr=1-2-0bff13d2-7188-4a82-bb3a-ccd1e70f0167-spons&sp_csd=d2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM&th=1&linkCode=ll1&tag=cryptobartlsh-21&linkId=421f8cde438e26a3b96259a4844b47aa&language=de_DE&ref_=as_li_ss_tl', 
            'https://www.amazon.de/Kaffeetasse-Keramikbecher-Kaffeebecher-Porzellan-Cappuccino/dp/B0921KVDJC?dib=eyJ2IjoiMSJ9.Up5H07KsZ_YHl8P4uknlnmng6j684v0jPGptodRVEy_l4Lm3kW1f-qQrYGg6nUr-Of6al__75WsN2DLoBH_9Ij7Zq05P0LKuhCCyBgLgy0eZbldgwVbfKMweab4Z5qWQKLca9WCQ-KFCUxw82B4RlPbu3RegEzvKoLsBOs0pMvESoGTwA4dYy4cU8RPad0GSmTc814IVm57dACPA8UDo4lHtJIGE33F56ShEy3mO-Mj5l8WVAMXPDfOpQjQftYGK6W_BEMy7wBRuTBtJ47WObNM7wt_HuFlHkDZDx28ZsEs.5UDtV9lmbn2AIbJFcsPhC42SAnW1u2UDWlM70G_UhP8&dib_tag=se&keywords=shiba%2Binu&qid=1749755278&sr=8-51&th=1&linkCode=ll1&tag=cryptobartlsh-21&linkId=ff2a518d9c7ec40c93bd7ca1aa35db07&language=de_DE&ref_=as_li_ss_tl',
             'https://www.amazon.de/Stolze-Keramik-Becher-Beidseitig-Bedruckt/dp/B094RD98CB?__mk_de_DE=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=3CMCPMUHIXUKA&dib=eyJ2IjoiMSJ9.rxjn1Z84tAXswdLSIPcf-M1qJ7nfh36ZNXCBUq-Z5zou2hA-EF796cn3G-ltSWAv-P79Nc3hynJgSp5awyrWilvUWZexovfpMoqXH-NR0O2TM1_t_d9kLnjQL7a_vV30JX1U5ly_QoCGFyMJlaO_6ixVZ-m7PZG784o_eCWNBRF2W9A5WMN_U_P5R57yyAHTAPQFf1t8FXiSbrFczXTvinLWe7KvhFw4LLQ7oPHQ3q5adpKe2SyKn_zMFZ7lUDsrnH8LoZp4jafpa-RlJ3nmASYvv5rPCPgU_F6KJ07YGWc._lm5exJ6lReqXqdCirkdi9-aKlbFTR2uFax13CZFCeo&dib_tag=se&keywords=shiba%2Binu&qid=1749755461&sprefix=shiba%2Binu%2Caps%2C110&sr=8-127&xpid=iXsOFItGEAU_2&th=1&linkCode=ll1&tag=cryptobartlsh-21&linkId=ce1ad96e2091c50593a45c1d4e07f4b1&language=de_DE&ref_=as_li_ss_tl'],
        Australia: [' BULLDOG Sculpture Tablet ', ' Shiba Inu Coffee Mug ', ' Shiba Inu Stolze Mama Coffee Mug '],
        AustraliaURL: ['https://www.amazon.de/OKESYO-Franz%C3%B6sische-Wohnzimmer-Eingangsbereich-Schreibtischdekoration/dp/B0C32MZH1Q?content-id=amzn1.sym.c1dd0633-066b-48a5-834b-1a99dc75ad66%3Aamzn1.sym.c1dd0633-066b-48a5-834b-1a99dc75ad66&cv_ct_cx=shiba%2Binu&keywords=shiba%2Binu&pd_rd_i=B0C32MZH1Q&pd_rd_r=a4e53393-171d-4355-b5e0-4b8ef0b5b5a4&pd_rd_w=ZAIde&pd_rd_wg=UxF2S&pf_rd_p=c1dd0633-066b-48a5-834b-1a99dc75ad66&pf_rd_r=81TGWY6NSGGGAZH526DB&qid=1749747969&sbo=RZvfv%2F%2FHxDF%2BO5021pAnSA%3D%3D&sr=1-2-0bff13d2-7188-4a82-bb3a-ccd1e70f0167-spons&sp_csd=d2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM&th=1&linkCode=ll1&tag=cryptobartlsh-21&linkId=421f8cde438e26a3b96259a4844b47aa&language=de_DE&ref_=as_li_ss_tl', 
                 'https://www.amazon.de/Kaffeetasse-Keramikbecher-Kaffeebecher-Porzellan-Cappuccino/dp/B0921KVDJC?dib=eyJ2IjoiMSJ9.Up5H07KsZ_YHl8P4uknlnmng6j684v0jPGptodRVEy_l4Lm3kW1f-qQrYGg6nUr-Of6al__75WsN2DLoBH_9Ij7Zq05P0LKuhCCyBgLgy0eZbldgwVbfKMweab4Z5qWQKLca9WCQ-KFCUxw82B4RlPbu3RegEzvKoLsBOs0pMvESoGTwA4dYy4cU8RPad0GSmTc814IVm57dACPA8UDo4lHtJIGE33F56ShEy3mO-Mj5l8WVAMXPDfOpQjQftYGK6W_BEMy7wBRuTBtJ47WObNM7wt_HuFlHkDZDx28ZsEs.5UDtV9lmbn2AIbJFcsPhC42SAnW1u2UDWlM70G_UhP8&dib_tag=se&keywords=shiba%2Binu&qid=1749755278&sr=8-51&th=1&linkCode=ll1&tag=cryptobartlsh-21&linkId=ff2a518d9c7ec40c93bd7ca1aa35db07&language=de_DE&ref_=as_li_ss_tl',
                  'https://www.amazon.de/Stolze-Keramik-Becher-Beidseitig-Bedruckt/dp/B094RD98CB?__mk_de_DE=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=3CMCPMUHIXUKA&dib=eyJ2IjoiMSJ9.rxjn1Z84tAXswdLSIPcf-M1qJ7nfh36ZNXCBUq-Z5zou2hA-EF796cn3G-ltSWAv-P79Nc3hynJgSp5awyrWilvUWZexovfpMoqXH-NR0O2TM1_t_d9kLnjQL7a_vV30JX1U5ly_QoCGFyMJlaO_6ixVZ-m7PZG784o_eCWNBRF2W9A5WMN_U_P5R57yyAHTAPQFf1t8FXiSbrFczXTvinLWe7KvhFw4LLQ7oPHQ3q5adpKe2SyKn_zMFZ7lUDsrnH8LoZp4jafpa-RlJ3nmASYvv5rPCPgU_F6KJ07YGWc._lm5exJ6lReqXqdCirkdi9-aKlbFTR2uFax13CZFCeo&dib_tag=se&keywords=shiba%2Binu&qid=1749755461&sprefix=shiba%2Binu%2Caps%2C110&sr=8-127&xpid=iXsOFItGEAU_2&th=1&linkCode=ll1&tag=cryptobartlsh-21&linkId=ce1ad96e2091c50593a45c1d4e07f4b1&language=de_DE&ref_=as_li_ss_tl'],
        China: [' BULLDOG Sculpture Tablet ', ' Shiba Inu Coffee Mug ', ' Shiba Inu Stolze Mama Coffee Mug '],
        ChinaURL: ['https://www.amazon.de/OKESYO-Franz%C3%B6sische-Wohnzimmer-Eingangsbereich-Schreibtischdekoration/dp/B0C32MZH1Q?content-id=amzn1.sym.c1dd0633-066b-48a5-834b-1a99dc75ad66%3Aamzn1.sym.c1dd0633-066b-48a5-834b-1a99dc75ad66&cv_ct_cx=shiba%2Binu&keywords=shiba%2Binu&pd_rd_i=B0C32MZH1Q&pd_rd_r=a4e53393-171d-4355-b5e0-4b8ef0b5b5a4&pd_rd_w=ZAIde&pd_rd_wg=UxF2S&pf_rd_p=c1dd0633-066b-48a5-834b-1a99dc75ad66&pf_rd_r=81TGWY6NSGGGAZH526DB&qid=1749747969&sbo=RZvfv%2F%2FHxDF%2BO5021pAnSA%3D%3D&sr=1-2-0bff13d2-7188-4a82-bb3a-ccd1e70f0167-spons&sp_csd=d2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM&th=1&linkCode=ll1&tag=cryptobartlsh-21&linkId=421f8cde438e26a3b96259a4844b47aa&language=de_DE&ref_=as_li_ss_tl', 
                      'https://www.amazon.de/Kaffeetasse-Keramikbecher-Kaffeebecher-Porzellan-Cappuccino/dp/B0921KVDJC?dib=eyJ2IjoiMSJ9.Up5H07KsZ_YHl8P4uknlnmng6j684v0jPGptodRVEy_l4Lm3kW1f-qQrYGg6nUr-Of6al__75WsN2DLoBH_9Ij7Zq05P0LKuhCCyBgLgy0eZbldgwVbfKMweab4Z5qWQKLca9WCQ-KFCUxw82B4RlPbu3RegEzvKoLsBOs0pMvESoGTwA4dYy4cU8RPad0GSmTc814IVm57dACPA8UDo4lHtJIGE33F56ShEy3mO-Mj5l8WVAMXPDfOpQjQftYGK6W_BEMy7wBRuTBtJ47WObNM7wt_HuFlHkDZDx28ZsEs.5UDtV9lmbn2AIbJFcsPhC42SAnW1u2UDWlM70G_UhP8&dib_tag=se&keywords=shiba%2Binu&qid=1749755278&sr=8-51&th=1&linkCode=ll1&tag=cryptobartlsh-21&linkId=ff2a518d9c7ec40c93bd7ca1aa35db07&language=de_DE&ref_=as_li_ss_tl',
                       'https://www.amazon.de/Stolze-Keramik-Becher-Beidseitig-Bedruckt/dp/B094RD98CB?__mk_de_DE=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=3CMCPMUHIXUKA&dib=eyJ2IjoiMSJ9.rxjn1Z84tAXswdLSIPcf-M1qJ7nfh36ZNXCBUq-Z5zou2hA-EF796cn3G-ltSWAv-P79Nc3hynJgSp5awyrWilvUWZexovfpMoqXH-NR0O2TM1_t_d9kLnjQL7a_vV30JX1U5ly_QoCGFyMJlaO_6ixVZ-m7PZG784o_eCWNBRF2W9A5WMN_U_P5R57yyAHTAPQFf1t8FXiSbrFczXTvinLWe7KvhFw4LLQ7oPHQ3q5adpKe2SyKn_zMFZ7lUDsrnH8LoZp4jafpa-RlJ3nmASYvv5rPCPgU_F6KJ07YGWc._lm5exJ6lReqXqdCirkdi9-aKlbFTR2uFax13CZFCeo&dib_tag=se&keywords=shiba%2Binu&qid=1749755461&sprefix=shiba%2Binu%2Caps%2C110&sr=8-127&xpid=iXsOFItGEAU_2&th=1&linkCode=ll1&tag=cryptobartlsh-21&linkId=ce1ad96e2091c50593a45c1d4e07f4b1&language=de_DE&ref_=as_li_ss_tl'],
    };

    const itemsVehicles = {
        Europe: [' Tool Case ', ' Ediag Diagnostic Tool ', ' USB Car Phone Charger '],
        EuropeURL: ['https://www.amazon.de/Mannesmann-M98430-Steckschl%C3%BCsselsatz-Antrieb-215-teilig/dp/B000K2PF4Y?crid=315EKVG2CTY3T&dib=eyJ2IjoiMSJ9.B_-t9hlzPZrcmlaaWzNZtfluKa-7Fxxw3ftA31OcwmCgFjmGLPOwaHxeu1srDjHHGkmove6QLcX0946w_nv621tPBmOumR144ncUk_FDzZsO780vRo8BVC7s-E-tOWd6GSe1ZMdm7pBcC8qTuqwNajnnE3IEwRNsf5BMZa3946m-RwElZSsyQM-6_qXqM_HkYgaXQrCONOhkMSGVpZNBSOKbSDFaUrw4noQrbMLd_DE.So_3QLFr5O-vqrK_rbTGVp4u5AXx8lDJPBw1ESqwyds&dib_tag=se&keywords=werkzeugkoffer&qid=1749755827&sprefix=werkzeug%2Caps%2C91&sr=8-13&th=1&linkCode=ll1&tag=cryptobartlsh-21&linkId=aea6fcae04c672e8bb4f8a46b59ac6fd&language=de_DE&ref_=as_li_ss_tl',
             'https://www.amazon.de/KINGBOLEN-EDIAG-Diagnoseger%C3%A4t-Ausleseger%C3%A4t-Fahrzeugleistungstest/dp/B0DPW35PHN?crid=2S13NZ68A6B1B&dib=eyJ2IjoiMSJ9.iINc6ERY60KIG9B4ViG47bHV8OwqvHH21mIxS7-V94pF6-j7aAfWuVqRQrD9mvtbTZ9c8tgySavR-4Xt8JnoPKRyiT9oexdPeOK9JCsVw7QoZrjOIKikqB_6sNxNhCx8chzz598Qb_CFxzHYnONZG-lAlr2dsoThGNZTph0Y2wSCdaOrdUpDuWHJRMyjajmTsjFWf1AC2QklCOCj11--P-yqNdIf6nqio-5BqG1xbHcTtOwz3jGwbMLEb0nrzGwulUfOSVPG2oNlgB76qmLousRkSqs4jNoHlEcY2meud4s.gV66lIj9Q8mOCAjzQunog1C69pFHalH-wMueEKtCR7c&dib_tag=se&keywords=car+diagnostic+tool&qid=1749755939&sprefix=car+dia%2Caps%2C116&sr=8-18&linkCode=ll1&tag=cryptobartlsh-21&linkId=9968c84c2125076274eb73f60916d297&language=de_DE&ref_=as_li_ss_tl',
              'https://www.amazon.de/Lamicall-Zigarettenanz%C3%BCnder-Kompakt%E3%80%9150W-Schnellladeger%C3%A4t-einziehbare-Grau/dp/B0F21QKF44?crid=BBSWE3ADZ1IV&dib=eyJ2IjoiMSJ9.cfqANIA9bdblIeCQHQhyR20LSnSYPpVLSmBZ0sUft4hPa0SwllcxMkQYypim5meOtVWffaCzwBfM3oKML7v19hqYA-4tWDoiuuRmUkCVQon8QRVqfTBvfsZjTDPov8Q31_N6F2fQfEV7-czhaxt15zgA7pqqPoNt3AZxWKNDkIXhBB1t5SES8kcgXY0oWYONJwSW0zYZx7oxzGlayQLuE-qojmFbdkH-Fd2ftDGVoXg.YT5SN59pbzaUNJ03QWu6Ce9qx2p0vNlZ7h4XLHMLsaY&dib_tag=se&keywords=usb+ladeger%C3%A4t+auto&qid=1749756196&sprefix=usb+ladeger%2Caps%2C117&sr=8-3-spons&sp_csd=d2lkZ2V0TmFtZT1zcF9hdGY&psc=1&linkCode=ll1&tag=cryptobartlsh-21&linkId=8c08d25b5fb8a35b3c9b91da9323c542&language=de_DE&ref_=as_li_ss_tl'],
        Australia: [' Tool Case ', ' Ediag Diagnostic Tool ', ' USB Car Phone Charger '],
        AustraliaURL: ['https://www.amazon.de/Mannesmann-M98430-Steckschl%C3%BCsselsatz-Antrieb-215-teilig/dp/B000K2PF4Y?crid=315EKVG2CTY3T&dib=eyJ2IjoiMSJ9.B_-t9hlzPZrcmlaaWzNZtfluKa-7Fxxw3ftA31OcwmCgFjmGLPOwaHxeu1srDjHHGkmove6QLcX0946w_nv621tPBmOumR144ncUk_FDzZsO780vRo8BVC7s-E-tOWd6GSe1ZMdm7pBcC8qTuqwNajnnE3IEwRNsf5BMZa3946m-RwElZSsyQM-6_qXqM_HkYgaXQrCONOhkMSGVpZNBSOKbSDFaUrw4noQrbMLd_DE.So_3QLFr5O-vqrK_rbTGVp4u5AXx8lDJPBw1ESqwyds&dib_tag=se&keywords=werkzeugkoffer&qid=1749755827&sprefix=werkzeug%2Caps%2C91&sr=8-13&th=1&linkCode=ll1&tag=cryptobartlsh-21&linkId=aea6fcae04c672e8bb4f8a46b59ac6fd&language=de_DE&ref_=as_li_ss_tl',
                   'https://www.amazon.de/KINGBOLEN-EDIAG-Diagnoseger%C3%A4t-Ausleseger%C3%A4t-Fahrzeugleistungstest/dp/B0DPW35PHN?crid=2S13NZ68A6B1B&dib=eyJ2IjoiMSJ9.iINc6ERY60KIG9B4ViG47bHV8OwqvHH21mIxS7-V94pF6-j7aAfWuVqRQrD9mvtbTZ9c8tgySavR-4Xt8JnoPKRyiT9oexdPeOK9JCsVw7QoZrjOIKikqB_6sNxNhCx8chzz598Qb_CFxzHYnONZG-lAlr2dsoThGNZTph0Y2wSCdaOrdUpDuWHJRMyjajmTsjFWf1AC2QklCOCj11--P-yqNdIf6nqio-5BqG1xbHcTtOwz3jGwbMLEb0nrzGwulUfOSVPG2oNlgB76qmLousRkSqs4jNoHlEcY2meud4s.gV66lIj9Q8mOCAjzQunog1C69pFHalH-wMueEKtCR7c&dib_tag=se&keywords=car+diagnostic+tool&qid=1749755939&sprefix=car+dia%2Caps%2C116&sr=8-18&linkCode=ll1&tag=cryptobartlsh-21&linkId=9968c84c2125076274eb73f60916d297&language=de_DE&ref_=as_li_ss_tl',
                    'https://www.amazon.de/Lamicall-Zigarettenanz%C3%BCnder-Kompakt%E3%80%9150W-Schnellladeger%C3%A4t-einziehbare-Grau/dp/B0F21QKF44?crid=BBSWE3ADZ1IV&dib=eyJ2IjoiMSJ9.cfqANIA9bdblIeCQHQhyR20LSnSYPpVLSmBZ0sUft4hPa0SwllcxMkQYypim5meOtVWffaCzwBfM3oKML7v19hqYA-4tWDoiuuRmUkCVQon8QRVqfTBvfsZjTDPov8Q31_N6F2fQfEV7-czhaxt15zgA7pqqPoNt3AZxWKNDkIXhBB1t5SES8kcgXY0oWYONJwSW0zYZx7oxzGlayQLuE-qojmFbdkH-Fd2ftDGVoXg.YT5SN59pbzaUNJ03QWu6Ce9qx2p0vNlZ7h4XLHMLsaY&dib_tag=se&keywords=usb+ladeger%C3%A4t+auto&qid=1749756196&sprefix=usb+ladeger%2Caps%2C117&sr=8-3-spons&sp_csd=d2lkZ2V0TmFtZT1zcF9hdGY&psc=1&linkCode=ll1&tag=cryptobartlsh-21&linkId=8c08d25b5fb8a35b3c9b91da9323c542&language=de_DE&ref_=as_li_ss_tl'],
        China: [' Tool Case ', ' Ediag Diagnostic Tool ', ' USB Car Phone Charger '],
        ChinaURL: ['https://www.amazon.de/Mannesmann-M98430-Steckschl%C3%BCsselsatz-Antrieb-215-teilig/dp/B000K2PF4Y?crid=315EKVG2CTY3T&dib=eyJ2IjoiMSJ9.B_-t9hlzPZrcmlaaWzNZtfluKa-7Fxxw3ftA31OcwmCgFjmGLPOwaHxeu1srDjHHGkmove6QLcX0946w_nv621tPBmOumR144ncUk_FDzZsO780vRo8BVC7s-E-tOWd6GSe1ZMdm7pBcC8qTuqwNajnnE3IEwRNsf5BMZa3946m-RwElZSsyQM-6_qXqM_HkYgaXQrCONOhkMSGVpZNBSOKbSDFaUrw4noQrbMLd_DE.So_3QLFr5O-vqrK_rbTGVp4u5AXx8lDJPBw1ESqwyds&dib_tag=se&keywords=werkzeugkoffer&qid=1749755827&sprefix=werkzeug%2Caps%2C91&sr=8-13&th=1&linkCode=ll1&tag=cryptobartlsh-21&linkId=aea6fcae04c672e8bb4f8a46b59ac6fd&language=de_DE&ref_=as_li_ss_tl',
                         'https://www.amazon.de/KINGBOLEN-EDIAG-Diagnoseger%C3%A4t-Ausleseger%C3%A4t-Fahrzeugleistungstest/dp/B0DPW35PHN?crid=2S13NZ68A6B1B&dib=eyJ2IjoiMSJ9.iINc6ERY60KIG9B4ViG47bHV8OwqvHH21mIxS7-V94pF6-j7aAfWuVqRQrD9mvtbTZ9c8tgySavR-4Xt8JnoPKRyiT9oexdPeOK9JCsVw7QoZrjOIKikqB_6sNxNhCx8chzz598Qb_CFxzHYnONZG-lAlr2dsoThGNZTph0Y2wSCdaOrdUpDuWHJRMyjajmTsjFWf1AC2QklCOCj11--P-yqNdIf6nqio-5BqG1xbHcTtOwz3jGwbMLEb0nrzGwulUfOSVPG2oNlgB76qmLousRkSqs4jNoHlEcY2meud4s.gV66lIj9Q8mOCAjzQunog1C69pFHalH-wMueEKtCR7c&dib_tag=se&keywords=car+diagnostic+tool&qid=1749755939&sprefix=car+dia%2Caps%2C116&sr=8-18&linkCode=ll1&tag=cryptobartlsh-21&linkId=9968c84c2125076274eb73f60916d297&language=de_DE&ref_=as_li_ss_tl',
                          'https://www.amazon.de/Lamicall-Zigarettenanz%C3%BCnder-Kompakt%E3%80%9150W-Schnellladeger%C3%A4t-einziehbare-Grau/dp/B0F21QKF44?crid=BBSWE3ADZ1IV&dib=eyJ2IjoiMSJ9.cfqANIA9bdblIeCQHQhyR20LSnSYPpVLSmBZ0sUft4hPa0SwllcxMkQYypim5meOtVWffaCzwBfM3oKML7v19hqYA-4tWDoiuuRmUkCVQon8QRVqfTBvfsZjTDPov8Q31_N6F2fQfEV7-czhaxt15zgA7pqqPoNt3AZxWKNDkIXhBB1t5SES8kcgXY0oWYONJwSW0zYZx7oxzGlayQLuE-qojmFbdkH-Fd2ftDGVoXg.YT5SN59pbzaUNJ03QWu6Ce9qx2p0vNlZ7h4XLHMLsaY&dib_tag=se&keywords=usb+ladeger%C3%A4t+auto&qid=1749756196&sprefix=usb+ladeger%2Caps%2C117&sr=8-3-spons&sp_csd=d2lkZ2V0TmFtZT1zcF9hdGY&psc=1&linkCode=ll1&tag=cryptobartlsh-21&linkId=8c08d25b5fb8a35b3c9b91da9323c542&language=de_DE&ref_=as_li_ss_tl'],
    };

    const itemsNFL = {
      Europe: [' Football Mug Coffee Novelty Ceramic Mug & Cute Football Themed Spoon & Coaster Tray Dish ', ' Mattel Games Giant UNO NFL Game ', ' WILSON NFL Stride Pro Eco '],
      EuropeURL: ['https://www.amazon.com/Football-Novelty-Ceramic-Holidays-Birthdays/dp/B0D7WW9SNB?crid=UEE1O5S1NCCO&dib=eyJ2IjoiMSJ9.OQxah17CIvOAURimGkVy0fEXe79TqsyE5ZQ6A65RQRCh5UTdbyEc3Jj1Kvw7_7rRSUJeQjPkNRmgbzALxUC_IvJ8M03gIps4G31gcMRYBvg0g_jIyA7ak3ZpEr-IYUqzRIsk1Y-i0-8RGquF_4j11EpOfzengQBr3brY7KU7DxvH8oTJ3Bd3S46DiLa-LlAgHhaOWN2ZTWhWirxMBvPxkEpXTQX7Zxacgnv8psMo_v7Mw_UB4zPXoCwM4wL-JFZObQc16p593KTPPchgZtIJomuhV_AMBrS4DOsD0VXiAsY.CvXUTbXeFz6FrK2UkjuzKtOD2zhZg5aotJUtv8z_ODE&dib_tag=se&keywords=nfl+mug&qid=1750069802&sprefix=nfl+mu%2Caps%2C241&sr=8-12-spons&sp_csd=d2lkZ2V0TmFtZT1zcF9tdGY&psc=1&linkCode=ll1&tag=cryptobartlsh-20&linkId=6e86c4ac4f8eb4e72eb4a47fbcfd4afb&language=en_US&ref_=as_li_ss_tl',
         'https://www.amazon.com/Mattel-Games-Adults-Oversized-Collectible/dp/B0BBSWYXZL?crid=123PUDV3IVD08&dib=eyJ2IjoiMSJ9.LJpcqJ5DrYOcix1YOPm0wZlbAMm4w-nevuSt2x5QCQJV3OAoIklJV2fMaToHH14JvEjNBRD2MqJ2txh6gYGuaPahVoLO77T-z5XMLdNs4Td6iCSUIBItzP2FG2HeBDzQg68ifE913E5LL_TEUUaCufAsCoQ9ViWHVlamTkV6CrhJi4EbBCAtde1Byk5dIQ9xDdp_EcvBAFSWN3TZXpJg-nroIehHjAIoIGPF0xH6rcnnz6OaQbhKtSAcsUPnMS9pZHh8Wdxj6l5qpwh1nmMWRye9Egbh51FKh0bUOdgDm_o.rJ4RujHxmAl4EXq6vcaBVzpIYSnkyju72_ubPg4kWLw&dib_tag=se&keywords=nfl&qid=1750069718&sprefix=nfl%2Caps%2C221&sr=8-26&th=1&linkCode=ll1&tag=cryptobartlsh-20&linkId=edf7b310a7063b271ab685556bc12e9a&language=en_US&ref_=as_li_ss_tl',
          'https://www.amazon.com/WILSON-NFL-Stride-Pro-Football/dp/B0BRQWMN25?crid=123PUDV3IVD08&dib=eyJ2IjoiMSJ9.LJpcqJ5DrYOcix1YOPm0wZlbAMm4w-nevuSt2x5QCQJV3OAoIklJV2fMaToHH14JvEjNBRD2MqJ2txh6gYGuaPahVoLO77T-z5XMLdNs4Td6iCSUIBItzP2FG2HeBDzQg68ifE913E5LL_TEUUaCufAsCoQ9ViWHVlamTkV6CrhJi4EbBCAtde1Byk5dIQ9xDdp_EcvBAFSWN3TZXpJg-nroIehHjAIoIGPF0xH6rcnnz6OaQbhKtSAcsUPnMS9pZHh8Wdxj6l5qpwh1nmMWRye9Egbh51FKh0bUOdgDm_o.rJ4RujHxmAl4EXq6vcaBVzpIYSnkyju72_ubPg4kWLw&dib_tag=se&keywords=nfl&qid=1750069718&sprefix=nfl%2Caps%2C221&sr=8-53&th=1&psc=1&linkCode=ll1&tag=cryptobartlsh-20&linkId=2e2e54bab5f6b9b28872d67a5e38fd37&language=en_US&ref_=as_li_ss_tl'],
      Australia: [' Football Mug Coffee Novelty Ceramic Mug & Cute Football Themed Spoon & Coaster Tray Dish ', ' Mattel Games Giant UNO NFL Game ', ' WILSON NFL Stride Pro Eco '],
      AistraliaURL: ['https://www.amazon.com/Football-Novelty-Ceramic-Holidays-Birthdays/dp/B0D7WW9SNB?crid=UEE1O5S1NCCO&dib=eyJ2IjoiMSJ9.OQxah17CIvOAURimGkVy0fEXe79TqsyE5ZQ6A65RQRCh5UTdbyEc3Jj1Kvw7_7rRSUJeQjPkNRmgbzALxUC_IvJ8M03gIps4G31gcMRYBvg0g_jIyA7ak3ZpEr-IYUqzRIsk1Y-i0-8RGquF_4j11EpOfzengQBr3brY7KU7DxvH8oTJ3Bd3S46DiLa-LlAgHhaOWN2ZTWhWirxMBvPxkEpXTQX7Zxacgnv8psMo_v7Mw_UB4zPXoCwM4wL-JFZObQc16p593KTPPchgZtIJomuhV_AMBrS4DOsD0VXiAsY.CvXUTbXeFz6FrK2UkjuzKtOD2zhZg5aotJUtv8z_ODE&dib_tag=se&keywords=nfl+mug&qid=1750069802&sprefix=nfl+mu%2Caps%2C241&sr=8-12-spons&sp_csd=d2lkZ2V0TmFtZT1zcF9tdGY&psc=1&linkCode=ll1&tag=cryptobartlsh-20&linkId=6e86c4ac4f8eb4e72eb4a47fbcfd4afb&language=en_US&ref_=as_li_ss_tl',
         'https://www.amazon.com/Mattel-Games-Adults-Oversized-Collectible/dp/B0BBSWYXZL?crid=123PUDV3IVD08&dib=eyJ2IjoiMSJ9.LJpcqJ5DrYOcix1YOPm0wZlbAMm4w-nevuSt2x5QCQJV3OAoIklJV2fMaToHH14JvEjNBRD2MqJ2txh6gYGuaPahVoLO77T-z5XMLdNs4Td6iCSUIBItzP2FG2HeBDzQg68ifE913E5LL_TEUUaCufAsCoQ9ViWHVlamTkV6CrhJi4EbBCAtde1Byk5dIQ9xDdp_EcvBAFSWN3TZXpJg-nroIehHjAIoIGPF0xH6rcnnz6OaQbhKtSAcsUPnMS9pZHh8Wdxj6l5qpwh1nmMWRye9Egbh51FKh0bUOdgDm_o.rJ4RujHxmAl4EXq6vcaBVzpIYSnkyju72_ubPg4kWLw&dib_tag=se&keywords=nfl&qid=1750069718&sprefix=nfl%2Caps%2C221&sr=8-26&th=1&linkCode=ll1&tag=cryptobartlsh-20&linkId=edf7b310a7063b271ab685556bc12e9a&language=en_US&ref_=as_li_ss_tl',
          'https://www.amazon.com/WILSON-NFL-Stride-Pro-Football/dp/B0BRQWMN25?crid=123PUDV3IVD08&dib=eyJ2IjoiMSJ9.LJpcqJ5DrYOcix1YOPm0wZlbAMm4w-nevuSt2x5QCQJV3OAoIklJV2fMaToHH14JvEjNBRD2MqJ2txh6gYGuaPahVoLO77T-z5XMLdNs4Td6iCSUIBItzP2FG2HeBDzQg68ifE913E5LL_TEUUaCufAsCoQ9ViWHVlamTkV6CrhJi4EbBCAtde1Byk5dIQ9xDdp_EcvBAFSWN3TZXpJg-nroIehHjAIoIGPF0xH6rcnnz6OaQbhKtSAcsUPnMS9pZHh8Wdxj6l5qpwh1nmMWRye9Egbh51FKh0bUOdgDm_o.rJ4RujHxmAl4EXq6vcaBVzpIYSnkyju72_ubPg4kWLw&dib_tag=se&keywords=nfl&qid=1750069718&sprefix=nfl%2Caps%2C221&sr=8-53&th=1&psc=1&linkCode=ll1&tag=cryptobartlsh-20&linkId=2e2e54bab5f6b9b28872d67a5e38fd37&language=en_US&ref_=as_li_ss_tl'],
      China: [' Football Mug Coffee Novelty Ceramic Mug & Cute Football Themed Spoon & Coaster Tray Dish ', ' Mattel Games Giant UNO NFL Game ', ' WILSON NFL Stride Pro Eco '],
      ChinaURL: ['https://www.amazon.com/Football-Novelty-Ceramic-Holidays-Birthdays/dp/B0D7WW9SNB?crid=UEE1O5S1NCCO&dib=eyJ2IjoiMSJ9.OQxah17CIvOAURimGkVy0fEXe79TqsyE5ZQ6A65RQRCh5UTdbyEc3Jj1Kvw7_7rRSUJeQjPkNRmgbzALxUC_IvJ8M03gIps4G31gcMRYBvg0g_jIyA7ak3ZpEr-IYUqzRIsk1Y-i0-8RGquF_4j11EpOfzengQBr3brY7KU7DxvH8oTJ3Bd3S46DiLa-LlAgHhaOWN2ZTWhWirxMBvPxkEpXTQX7Zxacgnv8psMo_v7Mw_UB4zPXoCwM4wL-JFZObQc16p593KTPPchgZtIJomuhV_AMBrS4DOsD0VXiAsY.CvXUTbXeFz6FrK2UkjuzKtOD2zhZg5aotJUtv8z_ODE&dib_tag=se&keywords=nfl+mug&qid=1750069802&sprefix=nfl+mu%2Caps%2C241&sr=8-12-spons&sp_csd=d2lkZ2V0TmFtZT1zcF9tdGY&psc=1&linkCode=ll1&tag=cryptobartlsh-20&linkId=6e86c4ac4f8eb4e72eb4a47fbcfd4afb&language=en_US&ref_=as_li_ss_tl',
         'https://www.amazon.com/Mattel-Games-Adults-Oversized-Collectible/dp/B0BBSWYXZL?crid=123PUDV3IVD08&dib=eyJ2IjoiMSJ9.LJpcqJ5DrYOcix1YOPm0wZlbAMm4w-nevuSt2x5QCQJV3OAoIklJV2fMaToHH14JvEjNBRD2MqJ2txh6gYGuaPahVoLO77T-z5XMLdNs4Td6iCSUIBItzP2FG2HeBDzQg68ifE913E5LL_TEUUaCufAsCoQ9ViWHVlamTkV6CrhJi4EbBCAtde1Byk5dIQ9xDdp_EcvBAFSWN3TZXpJg-nroIehHjAIoIGPF0xH6rcnnz6OaQbhKtSAcsUPnMS9pZHh8Wdxj6l5qpwh1nmMWRye9Egbh51FKh0bUOdgDm_o.rJ4RujHxmAl4EXq6vcaBVzpIYSnkyju72_ubPg4kWLw&dib_tag=se&keywords=nfl&qid=1750069718&sprefix=nfl%2Caps%2C221&sr=8-26&th=1&linkCode=ll1&tag=cryptobartlsh-20&linkId=edf7b310a7063b271ab685556bc12e9a&language=en_US&ref_=as_li_ss_tl',
          'https://www.amazon.com/WILSON-NFL-Stride-Pro-Football/dp/B0BRQWMN25?crid=123PUDV3IVD08&dib=eyJ2IjoiMSJ9.LJpcqJ5DrYOcix1YOPm0wZlbAMm4w-nevuSt2x5QCQJV3OAoIklJV2fMaToHH14JvEjNBRD2MqJ2txh6gYGuaPahVoLO77T-z5XMLdNs4Td6iCSUIBItzP2FG2HeBDzQg68ifE913E5LL_TEUUaCufAsCoQ9ViWHVlamTkV6CrhJi4EbBCAtde1Byk5dIQ9xDdp_EcvBAFSWN3TZXpJg-nroIehHjAIoIGPF0xH6rcnnz6OaQbhKtSAcsUPnMS9pZHh8Wdxj6l5qpwh1nmMWRye9Egbh51FKh0bUOdgDm_o.rJ4RujHxmAl4EXq6vcaBVzpIYSnkyju72_ubPg4kWLw&dib_tag=se&keywords=nfl&qid=1750069718&sprefix=nfl%2Caps%2C221&sr=8-53&th=1&psc=1&linkCode=ll1&tag=cryptobartlsh-20&linkId=2e2e54bab5f6b9b28872d67a5e38fd37&language=en_US&ref_=as_li_ss_tl'],
  };


  const handleNext = () => {
    if (activeIndex < packages.length - 1) {
      setActiveIndex(activeIndex + 1);
    }
  };

  const handlePrev = () => {
    if (activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
    }
  };

  const handleSwipeLeft = () => {
    if (activeIndex < packages.length - 1) {
      setActiveIndex(activeIndex + 1);
    }
  };

  const handleSwipeRight = () => {
    if (activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
    }
  };

  const swipeHandlers = useSwipeable({
    onSwipedLeft: handleSwipeLeft,
    onSwipedRight: handleSwipeRight,
    trackMouse: true, // Allows swipe functionality with a mouse (optional)
  });


  return (
    <>
        <NavComponent />
        <br />
        <br />
        <h1 style = {{fontSize: '52px', textAlign:'center'}}> Request your own Token / NFT </h1>
        <br />
        <br />
        <a href="/TokenRequest" style={{ textDecoration: 'none' }}>
          <StyledButtonRequest>
          Go directly to Request Form
            <HiArrowRightOnRectangle />
          </StyledButtonRequest>
        </a> 
        <br />
        <br />
        <CarouselContainer>
            <ArrowButton onClick={handlePrev} disabled={activeIndex === 0} style={{ left: '150px' }}>
              &#8592;
            </ArrowButton>
            
            <CarouselContent>
              <div
                style={{
                  width: '100%',
                  maxWidth: '600px', // Fixed width for the carousel
                  height: 'auto', // Fixed height for the carousel
                  overflow: 'hidden', // Ensures content doesn't overflow
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center', // Centers content vertically
                  alignItems: 'center', // Centers content horizontally
                  backgroundColor: '#ffffff',
                  borderRadius: '15px',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                  margin: '0 auto',
                  padding: '10px', // Padding for inner content
                }}
                {...swipeHandlers}
              >
                <br />
                {/* Package Header */}
                <div
                  style={{
                    display: 'flex', // Flexbox for alignment
                    justifyContent: 'center', // Center horizontally
                    alignItems: 'center', // Center vertically (optional)
                    background: '#f0f0f0', // Gradient for a modern look                    color: '#ffffff',
                    borderRadius: '10px',
                    margin: '0 auto', // Center the container itself
                    textAlign: 'center',
                    width: '100%',
                  }}
                >
                  <h3 style={{ margin: '0', fontSize: '1.5rem' }}>{packages[activeIndex].title}</h3>
                </div>

                {/* Package Use Case */}
                <div>
                  <br />
                  <p style={{ margin: '0', fontSize: '1.1rem', color: '#333' }}>
                    <strong>Use Case:</strong> {packages[activeIndex].useCase}
                  </p>
                </div>
                <br />

                {/* Parent Container for Alignment */}
                <div style={{ paddingLeft: '20px', marginBottom: '20px' }}>
                  {/* Package Features */}
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginBottom: '20px' }}>
                    <p style={{ margin: '0 0 10px 0', fontSize: '1.1rem', color: '#333', textAlign: 'left' }}>
                      <strong>Features:</strong>
                    </p>
                    <ul style={{ listStyleType: 'none', padding: '0', margin: '0' }}>
                      {packages[activeIndex].features.map((feature, index) => (
                        <li
                          key={index}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: '10px',
                          }}
                        >
                          <span
                            style={{
                              display: 'inline-block',
                              width: '8px',
                              height: '8px',
                              backgroundColor: '#b86fec',
                              borderRadius: '50%',
                              marginRight: '10px',
                            }}
                          ></span>
                          <span style={{ fontSize: '0.95rem', color: '#555' }}>{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Package Customization */}
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginBottom: '20px' }}>
                    <p style={{ margin: '0 0 10px 0', fontSize: '1.1rem', color: '#333', textAlign: 'left' }}>
                      <strong>Customization:</strong>
                    </p>
                    <ul style={{ listStyleType: 'none', padding: '0', margin: '0' }}>
                      {packages[activeIndex].customization.map((feature, index) => (
                        <li
                          key={index}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: '10px',
                          }}
                        >
                          <span
                            style={{
                              display: 'inline-block',
                              width: '8px',
                              height: '8px',
                              backgroundColor: 'transparent',
                              border: '2px solid #b86fec',
                              borderRadius: '50%',
                              marginRight: '10px',
                            }}
                          ></span>
                          <span style={{ fontSize: '0.95rem', color: '#555' }}>{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                {/* Package Description */}
                <div>
                  <br />
                  <p style={{ margin: '0', fontSize: '1.1rem', color: '#333' }}>
                    <strong>Description:</strong> {packages[activeIndex].details}
                  </p>
                </div>
                <br />

                {/* Redirect Button */}
                <div
                  style={{
                    display: 'flex', // Use flexbox for alignment
                    justifyContent: 'center', // Center horizontally
                    alignItems: 'center', // Center vertically (optional, if needed)
                    marginTop: '20px',
                    margin: '0 auto', // Center the button container
                  }}
                >
                  <a
                    href="/TokenRequest"
                    style={{
                      display: 'inline-block',
                      backgroundColor: '#b86fec',
                      color: '#fff',
                      padding: '10px 20px',
                      border: 'ridge',
                      borderRadius: '8px',
                      textDecoration: 'none',
                      fontWeight: 'bold',
                      fontSize: '1rem',
                      transition: 'background-color 0.3s ease',
                    }}
                    onClick={() => {
                      localStorage.setItem('LS_TokenPackage', packages[activeIndex].title); // Store the selected package in localStorage
                    }}
                    onMouseEnter={(e) => (e.target.style.backgroundColor = '#9a5ecb')}
                    onMouseLeave={(e) => (e.target.style.backgroundColor = '#b86fec')}
                  >
                    Request The Package
                  </a>
                </div>
                <br />

                {/* Package Price */}
                <div
                  style={{
                    backgroundColor: '#f9f9f9',
                    borderRadius: '8px',
                    textAlign: 'center',
                    width: '100%',
                    fontWeight: 'bold',
                    fontSize: '1.5rem',
                    color: '#333',
                  }}
                >
                  Price: {packages[activeIndex].price}
                </div>
                <br />
                <p
                  style={{
                    fontSize: '0.9rem',
                    color: '#888',
                    textAlign: 'center',
                    marginTop: '5px',
                  }}
                >
                  *Price depends on the chosen blockchain and customizations. <br />Promotion and SellForETH options are not included.
                </p>
              </div>
            </CarouselContent>

            <ArrowButton onClick={handleNext} disabled={activeIndex === packages.length - 1} style={{ right: '150px' }}>
              &#8594;
            </ArrowButton>
            <NavigationDots>
              {packages.map((_, index) => (
                <Dot
                  key={index}
                  active={index === activeIndex}
                  onClick={() => setActiveIndex(index)}
                />
              ))}
            </NavigationDots>
          </CarouselContainer>
        <br />
        <br />
        <h1 style={{ fontSize: '52px', textAlign: 'center' }}>
          Affiliate Partner Shop
          
        </h1>
        <button
            onClick={() => setIsAffiliateShopVisible(!isAffiliateShopVisible)} // Toggle visibility
            style={{
              backgroundColor: 'transparent',
              border: 'none',
              cursor: 'pointer',
              marginLeft: '10px',
              fontSize: '24px',
              color: '#b86fec',
            }}
          >
          {isAffiliateShopVisible ? <FaArrowUp /> : <FaArrowDown />}
          </button>
        <br />
        
        {isAffiliateShopVisible && (
        <div id='AffiliateShopContent'>
          <p>As an Amazon Associate I earn from qualifying purchases.</p>
          <br />
          <br />
            <StyledDiv id='Cocktails'>

            <StyledHeader onClick={() => setIsVisibleCocktail(!isVisibleCocktail)}>
                Cocktails
                {isVisibleCocktail ? <HiChevronUp size={24} style={{ marginLeft: '10px' }} /> : <HiChevronDown size={24} style={{ marginLeft: '10px' }} />}
            </StyledHeader>

            {isVisibleCocktail && (
                <>
                <div>
                    <StyledButton 
                      onClick={() => setCategory('Europe')} 
                      isSelected={category === 'Europe'}
                    >
                      Europe/Int
                    </StyledButton>
                    <StyledButton 
                      onClick={() => setCategory('Australia')} 
                      isSelected={category === 'Australia'}
                    >
                      Australia
                    </StyledButton>
                    <StyledButton 
                      onClick={() => setCategory('China')} 
                      isSelected={category === 'China'}
                    >
                      China
                    </StyledButton>

                    <h2>Chosen Category: {category.charAt(0).toUpperCase() + category.slice(1)}</h2>
                    <StyledItemList>
                      {itemsCocktails[category]?.map((item, index) => (
                        <StyledItem key={index}>
                          <a 
                            href={itemsCocktails[`${category}URL`]?.[index]} 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            style={{ color: 'inherit', textDecoration: 'none' }}
                          >
                            <FaAmazon size={20} style={{ marginLeft: '10px', color: '#FF9900' }} /> {/* Amazon icon */}
                        {item}
                        <FaExternalLinkAlt size={16} style={{ marginLeft: '5px', color: '#888' }} /> {/* External link icon */}
                          </a>
                        </StyledItem>
                      ))}
                    </StyledItemList>
                </div>
                </>
            )}
            </StyledDiv>
            <br />
            <br />

            <StyledDiv id='Dogs'>
            
            <StyledHeader onClick={() => setIsVisibleDog(!isVisibleDog)}>
                Dogs & Cats
                {isVisibleDog ? <HiChevronUp size={24} style={{ marginLeft: '10px' }} /> : <HiChevronDown size={24} style={{ marginLeft: '10px' }} />}
            </StyledHeader>

            {isVisibleDog && (
                <>
                <div>
                    <StyledButton onClick={() => setCategory('Europe')} 
                                  isSelected={category === 'Europe'}
                    >Europe/Int</StyledButton>
                    <StyledButton onClick={() => setCategory('Australia')}
                                  isSelected={category === 'Australia'}    
                    >Australia</StyledButton>
                    <StyledButton onClick={() => setCategory('China')}
                                  isSelected={category === 'China'}
                    >China</StyledButton>
                </div>
                <h2>Chosen Category: {category.charAt(0).toUpperCase() + category.slice(1)}</h2>
                <StyledItemList>
                    {itemsDogs[category].map((item, index) => (
                    <StyledItem key={index}>
                        <a 
                        href={itemsDogs[`${category}URL`][index]} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        style={{ color: 'inherit', textDecoration: 'none' }}
                        >
                        <FaAmazon size={20} style={{ marginLeft: '10px', color: '#FF9900' }} /> {/* Amazon icon */}
                        {item}
                        <FaExternalLinkAlt size={16} style={{ marginLeft: '5px', color: '#888' }} /> {/* External link icon */}
                        </a>
                    </StyledItem>
                    ))}
                </StyledItemList>
                </>
            )}
            </StyledDiv>
            <br />
            <br />

            <StyledDiv id='Vehicles'>
            
            <StyledHeader onClick={() => setIsVisibleVehicle(!isVisibleVehicle)}>
                Vehicles
                {isVisibleVehicle ? <HiChevronUp size={24} style={{ marginLeft: '10px' }} /> : <HiChevronDown size={24} style={{ marginLeft: '10px' }} />}
            </StyledHeader>

            {isVisibleVehicle && (
                <>
                <div>
                    <StyledButton onClick={() => setCategory('Europe')} 
                                  isSelected={category === 'Europe'}
                    >Europe/Int</StyledButton>
                    <StyledButton onClick={() => setCategory('Australia')}
                                  isSelected={category === 'Australia'}    
                    >Australia</StyledButton>
                    <StyledButton onClick={() => setCategory('China')}
                                  isSelected={category === 'China'}
                    >China</StyledButton>
                </div>
                <h2>Chosen Category: {category.charAt(0).toUpperCase() + category.slice(1)}</h2>
                <StyledItemList>
                    {itemsVehicles[category].map((item, index) => (
                    <StyledItem key={index}>
                        <a 
                        href={itemsVehicles[`${category}URL`][index]} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        style={{ color: 'inherit', textDecoration: 'none' }}
                        >
                        <FaAmazon size={20} style={{ marginLeft: '10px', color: '#FF9900' }} /> {/* Amazon icon */}
                        {item}
                        <FaExternalLinkAlt size={16} style={{ marginLeft: '5px', color: '#888' }} /> {/* External link icon */}
                        </a>
                    </StyledItem>
                    ))}
                </StyledItemList>
                </>
            )}
            </StyledDiv>
            <br />
            <br />

            <StyledDiv id='NFL'>
            
            <StyledHeader onClick={() => setIsVisibleNFL(!isVisibleNFL)}>
                NFL - The American Football
                {isVisibleNFL ? <HiChevronUp size={24} style={{ marginLeft: '10px' }} /> : <HiChevronDown size={24} style={{ marginLeft: '10px' }} />}
            </StyledHeader>

            {isVisibleNFL && (
                <>
                <div>
                    <StyledButton onClick={() => setCategory('Europe')} 
                                  isSelected={category === 'Europe'}
                    >Europe/Int</StyledButton>
                    <StyledButton onClick={() => setCategory('Australia')}
                                  isSelected={category === 'Australia'}    
                    >Australia</StyledButton>
                    <StyledButton onClick={() => setCategory('China')}
                                  isSelected={category === 'China'}
                    >China</StyledButton>
                </div>
                <h2>Chosen Category: {category.charAt(0).toUpperCase() + category.slice(1)}</h2>
                <StyledItemList>
                    {itemsNFL[category].map((item, index) => (
                    <StyledItem key={index}>
                        <a 
                        href={itemsNFL[`${category}URL`][index]} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        style={{ color: 'inherit', textDecoration: 'none' }}
                        >
                        <FaAmazon size={20} style={{ marginLeft: '10px', color: '#FF9900' }} /> {/* Amazon icon */}
                        {item}
                        <FaExternalLinkAlt size={16} style={{ marginLeft: '5px', color: '#888' }} /> {/* External link icon */}
                        </a>
                    </StyledItem>
                    ))}
                </StyledItemList>
                </>
            )}
            </StyledDiv>
            <br />
            <br />
        </div>)}
    </>
  );
}

export default Shop;
